import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const FirstHeading = styled.div`
  padding-bottom: 3rem;
  margin: 0 auto;

  @media screen and (max-width: ${layout.lg}) {
    padding-bottom: 1rem;
    width: 80%;
  }

  @media screen and (max-width: ${layout.md}) {
    & > h1 {
      font-size: 2.2rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    width: auto;

    & > h1 {
      font-size: 2rem;
    }
  }
`

export const PreludeParagraph = styled.div`
  width: 68%;
  margin: 0 auto;
  padding-bottom: 3rem;

  @media screen and (max-width: ${layout.md}) {
    & > p {
      font-size: 1.5rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    width: 80%;

    & > p {
      font-size: 1.3rem;
    }
  }
`

export const SecondHeading = styled.div`
  width: 80%;
  margin: 0 auto;
  padding-bottom: 1rem;
`

export const PrologueParagraph = styled.div`
  width: 60%;
  margin: 0 auto;

  @media screen and (max-width: ${layout.lg}) {
    width: 80%;
  }

  @media screen and (max-width: ${layout.md}) {
    & > p {
      font-size: 1.5rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    width: 90%;

    & > p {
      font-size: 1.3rem;
    }
  }
`

export const PassionateWrapper = styled.div`
  padding: 5rem 0;
  width: 100% !important;

  @media screen and (max-width: ${layout.sm}) {
    padding: 3rem 0;
  }
`
export const PassionateImageWrapper = styled.div`
  padding-bottom: 2rem;
  position: relative;
  width: 95%;
  margin: 0 auto;

  & > .mobile-rectangles {
    display: none;
  }

  @media screen and (max-width: ${layout.md}) {
    width: 80%;
  }

  @media screen and (max-width: ${layout.sm}) {
    width: 55%;

    & > .desktop-rectangles {
      display: none;
    }

    & > .mobile-rectangles {
      display: block;
    }
  }

  @media screen and (max-width: ${layout.xs}) {
    width: 80%;
  }
`
